import React from 'react';
import { useNavigate } from 'react-router-dom';

const ComparisonSection = () => {
  const navigate = useNavigate();

  const handleDonateClick = () => {
    navigate('/donate');
  };

  return (
    <header className="relative w-screen h-screen overflow-hidden bg-white" style={{ margin: 0, padding: 0 }} role="banner">
      {/* Background video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="w-full h-full object-cover"
          style={{ margin: 0, padding: 0 }}
          x5VideoPlayerType="h5"
          x5VideoPlayerFullscreen="true"
          x5VideoOrientation="portraint"
          aria-label="MASS BODY PROJECT video presentation"
        >
          <source src={`${process.env.PUBLIC_URL}/MB_SHORTCLIP2.mp4`} type="video/mp4" />
        </video>
      </div>
      

      {/* Primary CTA positioned 120px from bottom - Pentagram Style */}
      <div className="absolute inset-0 z-10 flex items-end justify-center" style={{ paddingBottom: '120px' }}>
        <div className="max-w-7xl mx-auto px-8 md:px-16 lg:px-24 text-center">
          <button
            onClick={handleDonateClick}
            className="px-12 py-4 border-2 border-black bg-black text-white text-sm md:text-base font-normal tracking-wider transition-all duration-300 hover:bg-white hover:text-black"
            style={{ 
              fontFamily: 'Arial, Helvetica, sans-serif',
              letterSpacing: '0.15em',
            }}
            aria-label="Donate your body to art - MASS BODY PROJECT"
          >
            DONATE YOUR BODY TO ART
          </button>
        </div>
      </div>
    </header>
  );
};

export default ComparisonSection;
